import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useUsersStore } from '../store/usersStore'
import { updateUser } from '../utils/updateUser'
import type { ApiError } from '@/types/api'
import { useAuthStore } from '@/features/auth/store/authStore'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useUpdateUserMutation = (onSuccess?: () => void) => {
  const update = useUsersStore((state) => state.update)
  const loggedUser = useAuthStore((state) => state.user)
  const setLoggedUser = useAuthStore((state) => state.setUser)

  return useMutation({
    mutationFn: updateUser,
    onSuccess: ({ message, user }) => {
      update(user)
      if (user._id === loggedUser?._id) {
        setLoggedUser(user)
      }

      toast.success(message || 'User edited successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while editing user.')
    },
  })
}
